/**
 * ObsoleteBadge Component
 * Marks a Reseller Assets file that has been superseded. The file can still
 * be downloaded (e.g. for customers with older machines); the link fetches
 * the version that replaced it.
 */

import React from 'react';
import './Obsolete.css';

const formatDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const ObsoleteBadge = ({ obsolete, onDownloadCurrent }) => {
  if (!obsolete) return null;
  const tip = [`Obsolete${obsolete.at ? ' since ' + formatDate(obsolete.at) : ''}`];
  if (obsolete.note) tip.push(obsolete.note);
  tip.push('Kept for customers who still need this version.');

  const handleCurrent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDownloadCurrent(obsolete.replacedById, obsolete.replacedByName);
  };

  return (
    <div className="rf-obsolete">
      <span className="rf-obsolete-pill" title={tip.join(' - ')}>
        <i className="fas fa-archive"></i> Obsolete{obsolete.note ? `: ${obsolete.note}` : ''}
      </span>
      {obsolete.replacedById && onDownloadCurrent && (
        <button
          type="button"
          className="rf-obsolete-current"
          onClick={handleCurrent}
          title="Download the current version"
        >
          <i className="fas fa-arrow-right"></i> Current: {obsolete.replacedByName || 'newer version'}
        </button>
      )}
    </div>
  );
};

export default ObsoleteBadge;
